import React from "react";
import { Divider } from "primereact/divider";
import { NavLink } from "react-router-dom";
import pesil from "../assets/logo/pesil.jpg";
import ibmBP from "../assets/logo/ibm-bp.jpg";
export default function Footer() {
  return (
    <footer className="app-footer p-4">
      <div className="p-4">
        <div className="grid">
          <div className="col-12 md:col-4">
            <>
            
              <img alt="logo" src={pesil} height="40" className="mr-2" />
              <img src={ibmBP} height="40" className="mr-2" />
            </>
            <p className="line-height-3">
              We are Systems Engineering & Product LifeCycle Management Experts.
            </p>
          </div>
          <div className="col-12 md:col-4">
            <h4 className="mb-3">Our Services</h4>
            <ul className="list-none p-0 m-0 line-height-3">
              <li>
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    isActive ? "footer-link active" : "footer-link"
                  }
                >
                  Home
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/about"
                  className={({ isActive }) =>
                    isActive ? "footer-link active" : "footer-link"
                  }
                >
                  About Us
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/products"
                  className={({ isActive }) =>
                    isActive ? "footer-link active" : "footer-link"
                  }
                >
                  Products
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/services"
                  className={({ isActive }) =>
                    isActive ? "footer-link active" : "footer-link"
                  }
                >
                  Services
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/trainings"
                  className={({ isActive }) =>
                    isActive ? "footer-link active" : "footer-link"
                  }
                >
                  Trainings
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/contact"
                  className={({ isActive }) =>
                    isActive ? "footer-link active" : "footer-link"
                  }
                >
                  Contact Us
                </NavLink>
              </li>
            </ul>
          </div>
          <div className="col-12 md:col-4 contact-section">
            <h4 className="mb-3">Contact</h4>

            <p className="mb-2 contact-item">
              <i className="pi pi-envelope mr-2"></i>
              <a href="mailto:hr@pesilinfosol.com">hr@pesilinfosol.com</a>
            </p>

            <p className="mb-2 contact-item">
              <i className="pi pi-phone mr-2"></i>
              <a href="tel:+919442532239">+91-94425-32239</a>
            </p>
<p className="contact-item flex align-items-start">
  <i className="pi pi-map-marker mr-2 mt-1"></i>

  <span>
    <strong style={{color:"firebrick"}}>PESIL InfoSol Private Limited</strong><br />
    #21/5, South Center Block,<br />
    D'Silva Layout, Whitefield,<br />
    Bangalore - 560066,<br />
    Karnataka, India
  </span>
</p>


          </div>
        </div>
        <Divider />
        <hr/>
        <div className="flex justify-content-center">
          <span>© 2026 Pesilinfosol. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}
